import React, { useState } from 'react';

import { filter } from 'lodash-es';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { spacing } from 'styles/constants';
import { useAnchorContext } from 'utils/static-page/hooks/useAnchorContext';

import { AnchorLinkItem, AnchorLinks } from './styled';
import { AnchorLinksWidgetProps } from './types';

export const AnchorLinksWidget = (props: AnchorLinksWidgetProps) => {
  const { scrollToTarget, formatLocaleAnchorName } = useAnchorContext();
  const [currentPressedLink, setcurrentPressedLink] = useState<string | undefined>();

  return (
    <Box style={styles.container}>
      <AnchorLinks>
        {filter(props.widgets, ['_type', 'anchorWidget']).map(anchor => {
          const anchorName = anchor.anchorName?.locale;

          return (
            <AnchorLinkItem
              // href={`#${formatLocaleAnchorName(anchor.anchorName?.locale)}`} TODO: RN - ensure web/browser anchor navigation works
              key={anchor._key}
              isUnderlined={currentPressedLink === anchor.anchorName?.locale}
              onPress={() => {
                // TODO: RN move to a better place in the navigation/route handling logic? href/router currently creates exception when pressed
                setcurrentPressedLink(anchorName);
                scrollToTarget(formatLocaleAnchorName(anchorName));
              }}
            >
              {anchor.anchorName?.locale}
            </AnchorLinkItem>
          );
        })}
      </AnchorLinks>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.$4,
  },
});
